import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Shared flag indicating whether the super-admin bar is currently mounted.
 * Set by SuperAdminMenuComponent on init/destroy; consumed by layout-aware
 * components (e.g. IncidentBanner) to compute offsets.
 */
@Injectable({ providedIn: 'root' })
export class SuperAdminContextService {
  readonly present$ = new BehaviorSubject<boolean>(false);

  get present(): boolean {
    return this.present$.value;
  }

  set present(value: boolean) {
    if (this.present$.value !== value) {
      this.present$.next(value);
    }
  }
}
